export default "__VITE_ASSET__DpCo2T_n__"